import { Button, type SxProps, type Theme } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

type FormSubmitButtonProps = {
  children: ReactNode;
  onClick?: () => void | Promise<void>;
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  fullWidthOnMobile?: boolean;
  type?: 'button' | 'submit' | 'reset';
  sx?: SxProps<Theme>;
};

export const FormSubmitButton = ({
  children,
  onClick,
  loading = false,
  disabled = false,
  fullWidth = true,
  fullWidthOnMobile = true,
  type = 'button',
  sx,
}: FormSubmitButtonProps): ReactElement => {
  const widthSx: SxProps<Theme> | undefined = fullWidth ? { width: '100%' } : undefined;
  const resolvedSx = sx ? ([widthSx, sx].filter(Boolean) as SxProps<Theme>) : widthSx;
  return (
    <Button
      variant="primary"
      loading={loading}
      disabled={disabled}
      fullWidthOnMobile={fullWidthOnMobile}
      type={type}
      sx={resolvedSx}
      onClick={
        onClick
          ? () => {
              void onClick();
            }
          : undefined
      }
    >
      {children}
    </Button>
  );
};
